import { Navigate } from "react-router";
import { useGetLocationQuery } from "../../../apis/Location.api";
import { PrimaryLocation, Location } from "../../../types/models/Location";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const LocationScoped = () => {
    const {
        data,
    } = useGetLocationQuery(PrimaryLocation.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/locations/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default LocationScoped;
